import { ParsedUrlQuery } from 'querystring';
import { stringify } from 'query-string';
import { getQueryParam } from 'helpers/next-page';
import { getEnvLink } from 'helpers/routes';

export const ATHLETES_BASE_PATH = '/athletes';
export const ATHLETES_PER_PAGE = 20;

export const ATHLETES_PAGE_TITLE = 'MILLIONS.co - Athletes';

export { ATHLETES_PAGE_DESCRIPTION } from 'helpers/landingPageSeo';

export const getAthletesPageFromQuery = (query: ParsedUrlQuery): number => {
  const parsed = Number(getQueryParam(query.page));
  return Number.isFinite(parsed) && parsed >= 1 ? Math.floor(parsed) : 1;
};

export const getAthletesPageCount = (
  totalItems: number,
  perPage: number
): number => Math.max(1, Math.ceil(totalItems / perPage));

export const clampAthletesPage = (page: number, pageCount: number): number =>
  Math.min(Math.max(page, 1), pageCount);

/** Query params preserved in pagination links (everything except `page`). */
export const getAthletesPaginationQuery = (
  query: ParsedUrlQuery
): Record<string, string | string[] | undefined> => {
  const rest = { ...query };
  delete rest.page;
  return rest;
};

export const buildAthletesPageTitle = (page: number): string =>
  page > 1 ? `${ATHLETES_PAGE_TITLE} - Page ${page}` : ATHLETES_PAGE_TITLE;

export const buildAthletesCanonicalLink = (page: number): string | undefined =>
  page > 1 ? `${getEnvLink()}${ATHLETES_BASE_PATH}?page=${page}` : undefined;

export const buildAthletesPaginatedHref = (
  page: number,
  query: ParsedUrlQuery
): string => {
  const preserved = getAthletesPaginationQuery(query);
  const withPage = page > 1 ? { ...preserved, page: String(page) } : preserved;
  const qs = stringify(withPage, {
    arrayFormat: 'comma',
    skipNull: true,
    skipEmptyString: true,
  });

  return qs ? `${ATHLETES_BASE_PATH}?${qs}` : ATHLETES_BASE_PATH;
};
